import ApiService from "service/Api";
import { UserPayloadTypes } from "utilities/types/User";

const UserService = {
  getAllUsers: async (page: number, search: string, limit: number) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
      },
      url: "/admin/users",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getUser: async (userId: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/users/" + userId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeUser: async (payload: UserPayloadTypes) => {
    const {
      name,
      email,
      phoneNumber,
      password,
      role,
      phoneIsVerified,
      emailIsVerified,
      greeting,
      birthdate,
      address,
      tenantId,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        email: email,
        phone_number: phoneNumber,
        password: password,
        phone_is_verified: phoneIsVerified,
        email_is_verified: emailIsVerified,
        role: role,
        greeting: greeting,
        birthdate: birthdate,
        address: address,
        tenant_id: tenantId,
      },
      url: "/admin/users",
    };
    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateUser: async (userId: string, payload: UserPayloadTypes) => {
    const {
      name,
      email,
      phoneNumber,
      password,
      role,
      phoneIsVerified,
      emailIsVerified,
      greeting,
      birthdate,
      address,
      tenantId,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        email: email,
        phone_number: phoneNumber,
        password: password,
        phone_is_verified: phoneIsVerified,
        email_is_verified: emailIsVerified,
        role: role,
        greeting: greeting,
        birthdate: birthdate,
        address: address,
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "/admin/users/" + userId,
    };
    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteUser: async (userId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/users/" + userId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default UserService;
